import {
  EMPLOYEE_ADDITION_DEDUCTION_FETCHING,
  EMPLOYEE_ADDITION_DEDUCTION_FAILED,
  EMPLOYEE_ADDITION_DEDUCTION_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_ADDITION_DEDUCTION_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEE_ADDITION_DEDUCTION_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEE_ADDITION_DEDUCTION_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
